import { render, staticRenderFns } from "./EditDealer.vue?vue&type=template&id=71b0043f&"
import script from "./EditDealer.vue?vue&type=script&lang=ts&"
export * from "./EditDealer.vue?vue&type=script&lang=ts&"
import style0 from "./EditDealer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports